 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		91: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		91: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"18":"App2DPaymentComplete","19":"AppPayment","20":"AppPaymentComplete","21":"AppPaymentProcessing","22":"AxsTravelInsure","23":"BusinessProtect360.Generate","24":"CILeadForm","25":"CIP.FactFormApp","26":"CIProtect360.Dashboard","27":"CIProtect360.Details","28":"CIProtect360.Direct.Generate","29":"CIProtect360.Generate","30":"CampaignLeadForm","31":"CarProtect360","32":"CashCardShield","33":"ChoicesProtect360","34":"CommissionStatement","35":"Common.Error","36":"Common.MyInfoCallback","37":"ComplimentaryHomeContents","38":"ConsumerPortal","39":"ContactUs","40":"CorporateTravel","41":"Debug","42":"EMAPortal","43":"EarlyProtect360Plus","44":"EarlyProtect360Plus.Dashboard","45":"EarlyProtect360Plus.Details","46":"FamilyProtect360","47":"FamilyProtectLiteWithUpgrade","48":"FilipinoBond","49":"FlashPayShieldWithUpgrade","50":"FraudProtect360","51":"HIProtect360Protect360","52":"HomeProtect360","53":"HomeProtectLite","54":"HomeSafe","55":"HomeStarterKit","56":"InternalDemoCookie","57":"KeymanProtect360","58":"KeymanProtect360.Dashboard","59":"KeymanProtect360.Details","60":"LeadForm","61":"Loan Protect 360 Renewal","62":"LoanProtect360","63":"LoanProtect360.Dashboard","64":"LoanProtect360.Details","65":"MaidProtect360","66":"MotoringCardShieldWithUpgrade","67":"Motorshow2020","68":"PartnerProgram","69":"PhoneProtect360","70":"PowerAgentPortal","71":"Prestige","72":"Prestige.Secured","73":"PublicHousingAssured","74":"ReviewUs","75":"SBSTPAProtectLite","76":"SBSTPAProtectPlus","77":"SBSTTravelInsurance","78":"SOA","79":"SimplyGo","80":"SingaporeTravelPass","81":"Touristcard","82":"TravelAssured","83":"TravelAssuredPlus","84":"TravelProtect360","85":"TravelProtect360Plus","86":"cileadform","87":"currencyconverter","88":"freehomeinsurance","90":"motorshow","92":"transferprotect360pro","93":"vCashCard","94":"weather"}[chunkId]||chunkId) + "." + {"0":"d160a715","1":"1a33af82","2":"0b7ee7da","3":"abc5cfd5","4":"3993626c","5":"fd9a505a","6":"d0155bbe","7":"866d048d","8":"ebd3ab8f","9":"118bedb3","10":"47a3ffe1","11":"6a548dff","12":"df2df83c","13":"7ca1abae","14":"2672fbf5","15":"42d682fb","16":"3131be6a","17":"7b05aef2","18":"d4abbf6d","19":"7f22526d","20":"a5e1cf21","21":"3e6cf12f","22":"0c652c62","23":"832de8ad","24":"9cf54222","25":"9c3d4500","26":"b072cdfc","27":"52f4c007","28":"26d27740","29":"5a463115","30":"ba616a6d","31":"79a11919","32":"fe350d3a","33":"73750698","34":"7705dfc3","35":"10c186aa","36":"5d10c8f4","37":"0f7a754c","38":"d5ce1ace","39":"2e198860","40":"71a62523","41":"4a569531","42":"e1047ee0","43":"ed6c5909","44":"0f725486","45":"ec38a62c","46":"5e7a75d8","47":"25712cf3","48":"8d339c96","49":"31a6d902","50":"7186e67c","51":"e1e9bad6","52":"39a037fb","53":"10039db9","54":"3511ef91","55":"2b5507ae","56":"4fbdbc49","57":"538fded0","58":"14928b4c","59":"86f43db5","60":"d3425abe","61":"610d1796","62":"7c1afba2","63":"700cad97","64":"a6a28bbb","65":"6758ce4c","66":"bde13ad0","67":"ad9519f1","68":"e768b96f","69":"d90f2033","70":"9fa60d50","71":"a81ac1fd","72":"3b141322","73":"2c90bfcb","74":"709b9d5a","75":"185d847d","76":"7de51333","77":"f9921dc0","78":"df318835","79":"0c595ece","80":"442e6c71","81":"47bbb599","82":"6edae229","83":"7693ff2d","84":"21461e92","85":"38411488","86":"3c1038c3","87":"052d1e31","88":"1f1da692","90":"5db23254","92":"e0207244","93":"41be642c","94":"68cc5372","96":"c1c12604","97":"ac227af1","98":"21386b9f","99":"a7e9024b","100":"541ebf39","101":"bf319bc5","102":"8b85d06f","103":"0904c0a1","104":"46bc5bcf","105":"96f950d9","106":"fb8aac71","107":"970be755","108":"8076e779","109":"b421c983","110":"f7e105e2","111":"a481e5aa","112":"0f762e60","113":"0c67abac","114":"0e9f10d8","115":"2f057cb0","116":"4cc91ac9","117":"a42e93f8","118":"7dd021c8","119":"8a9cf7c4","120":"de61fc67","121":"830353c9","122":"f106591e","123":"1357e535","124":"a936429c","125":"9edcf514","126":"e8683eba","127":"d32de003","128":"81892550","129":"6f50f294","130":"7eb7537f","131":"514d77e9","132":"ae85c0b7","133":"36fe5427","134":"52320a12","135":"fadf4dca","136":"da6a3733","137":"da538500","138":"77e0e7f7","139":"0fe8916d","140":"586ba4b7","141":"506a9c15","142":"9be12cb5","143":"220865b8","144":"0c621856","145":"66dc52e8","146":"f4556c56","147":"22fdb794","148":"d2d431b0","149":"8d22e486","150":"4584b609","151":"180824da","152":"876dd94f","153":"b5db022f","154":"88269965","155":"c60df6b6","156":"8d6757ec","157":"052437b4","158":"b09926e3","159":"b78abd03","160":"7aa01a09","161":"11a6dcc6","162":"efeab6b0","163":"f29da242","164":"8f97dc73","165":"746ea210","166":"5ba8c058","167":"72e82905","168":"47448168","169":"82b0817c","170":"e2393c4e","171":"bb6932ca","172":"2151ad1d","173":"93fc7b26","174":"a37b1211","175":"6e15fea5","176":"6055a95f","177":"f41f1ee9"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"19":1,"21":1,"22":1,"23":1,"25":1,"28":1,"30":1,"31":1,"32":1,"33":1,"34":1,"37":1,"38":1,"40":1,"41":1,"43":1,"46":1,"47":1,"48":1,"49":1,"50":1,"51":1,"52":1,"53":1,"54":1,"55":1,"57":1,"60":1,"65":1,"66":1,"68":1,"69":1,"70":1,"71":1,"72":1,"73":1,"75":1,"76":1,"77":1,"78":1,"79":1,"80":1,"81":1,"82":1,"83":1,"84":1,"85":1,"86":1,"87":1,"88":1,"90":1,"92":1,"93":1,"94":1,"97":1,"98":1,"100":1,"101":1,"102":1,"103":1,"104":1,"105":1,"106":1,"107":1,"108":1,"109":1,"112":1,"116":1,"120":1,"121":1,"125":1,"126":1,"130":1,"131":1,"132":1,"133":1,"134":1,"135":1,"136":1,"137":1,"138":1,"139":1,"140":1,"141":1,"142":1,"143":1,"155":1,"156":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"18":"App2DPaymentComplete","19":"AppPayment","20":"AppPaymentComplete","21":"AppPaymentProcessing","22":"AxsTravelInsure","23":"BusinessProtect360.Generate","24":"CILeadForm","25":"CIP.FactFormApp","26":"CIProtect360.Dashboard","27":"CIProtect360.Details","28":"CIProtect360.Direct.Generate","29":"CIProtect360.Generate","30":"CampaignLeadForm","31":"CarProtect360","32":"CashCardShield","33":"ChoicesProtect360","34":"CommissionStatement","35":"Common.Error","36":"Common.MyInfoCallback","37":"ComplimentaryHomeContents","38":"ConsumerPortal","39":"ContactUs","40":"CorporateTravel","41":"Debug","42":"EMAPortal","43":"EarlyProtect360Plus","44":"EarlyProtect360Plus.Dashboard","45":"EarlyProtect360Plus.Details","46":"FamilyProtect360","47":"FamilyProtectLiteWithUpgrade","48":"FilipinoBond","49":"FlashPayShieldWithUpgrade","50":"FraudProtect360","51":"HIProtect360Protect360","52":"HomeProtect360","53":"HomeProtectLite","54":"HomeSafe","55":"HomeStarterKit","56":"InternalDemoCookie","57":"KeymanProtect360","58":"KeymanProtect360.Dashboard","59":"KeymanProtect360.Details","60":"LeadForm","61":"Loan Protect 360 Renewal","62":"LoanProtect360","63":"LoanProtect360.Dashboard","64":"LoanProtect360.Details","65":"MaidProtect360","66":"MotoringCardShieldWithUpgrade","67":"Motorshow2020","68":"PartnerProgram","69":"PhoneProtect360","70":"PowerAgentPortal","71":"Prestige","72":"Prestige.Secured","73":"PublicHousingAssured","74":"ReviewUs","75":"SBSTPAProtectLite","76":"SBSTPAProtectPlus","77":"SBSTTravelInsurance","78":"SOA","79":"SimplyGo","80":"SingaporeTravelPass","81":"Touristcard","82":"TravelAssured","83":"TravelAssuredPlus","84":"TravelProtect360","85":"TravelProtect360Plus","86":"cileadform","87":"currencyconverter","88":"freehomeinsurance","90":"motorshow","92":"transferprotect360pro","93":"vCashCard","94":"weather"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0","1":"31d6cfe0","2":"31d6cfe0","3":"31d6cfe0","4":"31d6cfe0","5":"31d6cfe0","6":"31d6cfe0","7":"31d6cfe0","8":"31d6cfe0","9":"31d6cfe0","10":"31d6cfe0","11":"31d6cfe0","12":"31d6cfe0","13":"31d6cfe0","14":"31d6cfe0","15":"31d6cfe0","16":"31d6cfe0","17":"31d6cfe0","18":"31d6cfe0","19":"a858c2f5","20":"31d6cfe0","21":"a858c2f5","22":"86c9f98d","23":"d30bc41f","24":"31d6cfe0","25":"d33f62d9","26":"31d6cfe0","27":"31d6cfe0","28":"58058363","29":"31d6cfe0","30":"05f863ac","31":"ddf1f108","32":"04bc7233","33":"ddf1f108","34":"d33f62d9","35":"31d6cfe0","36":"31d6cfe0","37":"0e4fba13","38":"978e5247","39":"31d6cfe0","40":"ac3f861f","41":"5d27deaa","42":"31d6cfe0","43":"58058363","44":"31d6cfe0","45":"31d6cfe0","46":"ddf1f108","47":"0e4fba13","48":"ddf1f108","49":"0e4fba13","50":"ddf1f108","51":"ddf1f108","52":"471a3a57","53":"471a3a57","54":"471a3a57","55":"0e4fba13","56":"31d6cfe0","57":"58058363","58":"31d6cfe0","59":"31d6cfe0","60":"dd9a60e3","61":"31d6cfe0","62":"31d6cfe0","63":"31d6cfe0","64":"31d6cfe0","65":"14284125","66":"0e4fba13","67":"31d6cfe0","68":"8b647349","69":"471a3a57","70":"716aad65","71":"2fc531d7","72":"cdec5a50","73":"471a3a57","74":"31d6cfe0","75":"39dd3a27","76":"e81d10c5","77":"86c9f98d","78":"d33f62d9","79":"98c15efc","80":"2e8fdc12","81":"344cc04e","82":"86c9f98d","83":"86c9f98d","84":"2e8fdc12","85":"86c9f98d","86":"22b92479","87":"7b4f34de","88":"0e4fba13","90":"49234f01","92":"14284125","93":"94b03ce8","94":"23255cb6","96":"31d6cfe0","97":"cce35a68","98":"440606be","99":"31d6cfe0","100":"2d576837","101":"166c8acc","102":"db5d06da","103":"f93319e8","104":"f93319e8","105":"72c6f688","106":"72c6f688","107":"72c6f688","108":"f93319e8","109":"72c6f688","110":"31d6cfe0","111":"31d6cfe0","112":"6f6df1fe","113":"31d6cfe0","114":"31d6cfe0","115":"31d6cfe0","116":"6f6df1fe","117":"31d6cfe0","118":"31d6cfe0","119":"31d6cfe0","120":"6f6df1fe","121":"6f6df1fe","122":"31d6cfe0","123":"31d6cfe0","124":"31d6cfe0","125":"4b48318c","126":"4b48318c","127":"31d6cfe0","128":"31d6cfe0","129":"31d6cfe0","130":"4b48318c","131":"4b48318c","132":"4b48318c","133":"4b48318c","134":"4b48318c","135":"4b48318c","136":"4b48318c","137":"4b48318c","138":"4b48318c","139":"4b48318c","140":"4b48318c","141":"4b48318c","142":"4b48318c","143":"4b48318c","144":"31d6cfe0","145":"31d6cfe0","146":"31d6cfe0","147":"31d6cfe0","148":"31d6cfe0","149":"31d6cfe0","150":"31d6cfe0","151":"31d6cfe0","152":"31d6cfe0","153":"31d6cfe0","154":"31d6cfe0","155":"5fe6802c","156":"5fe6802c","157":"31d6cfe0","158":"31d6cfe0","159":"31d6cfe0","160":"31d6cfe0","161":"31d6cfe0","162":"31d6cfe0","163":"31d6cfe0","164":"31d6cfe0","165":"31d6cfe0","166":"31d6cfe0","167":"31d6cfe0","168":"31d6cfe0","169":"31d6cfe0","170":"31d6cfe0","171":"31d6cfe0","172":"31d6cfe0","173":"31d6cfe0","174":"31d6cfe0","175":"31d6cfe0","176":"31d6cfe0","177":"31d6cfe0"}[chunkId] + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.hlas.com.sg/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonphlas-react-app"] = this["webpackJsonphlas-react-app"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
